import { render, staticRenderFns } from "./reportePtiPresupuestadoCDXEV2.vue?vue&type=template&id=33937217&scoped=true"
import script from "./reportePtiPresupuestadoCDXEV2.vue?vue&type=script&lang=js"
export * from "./reportePtiPresupuestadoCDXEV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33937217",
  null
  
)

export default component.exports